module.exports = __webpack_public_path__ + "static/media/img11.6c179747.svg";